import { render, staticRenderFns } from "./BoletosAdmin.vue?vue&type=template&id=2546c4b8&scoped=true&"
import script from "./BoletosAdmin.vue?vue&type=script&lang=js&"
export * from "./BoletosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BoletosAdmin.vue?vue&type=style&index=0&id=2546c4b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546c4b8",
  null
  
)

export default component.exports